import React                  from 'react';
import classnames             from 'classnames';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';

import PartNoImage            from 'images/bom/part-no-image.jpg'

import {
  getImageSrc,
}from 'pu-utils/PartsUtilities';    

const PartImage = (props) => {
  let image_src =  getImageSrc(props.images, props.selected_quantity);
  if (image_src == "") {
    image_src = PartNoImage;
  }

  return (
    <img className="part-image" 
     src={image_src} 
     alt="Part Image" />
  )
}

export default PartImage;